module.exports = require("!!vue-loader!../../node_modules/vue-markdown-loader/lib/markdown-compiler.js?raw!./deploy.md");


//////////////////
// WEBPACK FOOTER
// ./src/docs/deploy.md
// module id = 9jCT
// module chunks = 0